import React from 'react'
import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useQuery } from 'react-query'

// Libs
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { setFixedPlayerData } from '@/redux/reducers/common'
import { setRoomData } from '@/redux/reducers/room'
import { fetchRoomData } from '@/api/fetchRoomData'
import { differenceInMinutes, parseISO } from 'date-fns'
import { useLiveRoomProduct } from '@/hooks/useLiveRoomProduct'

// Components
import ProductList from '../LiveRoom/sharedComponents/ProductList'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { ROOM_LIVE_TYPE } from '@/constants/liveRoom'
import { ROLE } from '@/constants/role'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

// Context
export const LiveRoomProductContext = React.createContext({})

const LiveRoomProduct = ({ liveRoomProductDataSSR }: any) => {
  const dispatch = useAppDispatch()

  const router = useRouter()
  const memberData = useAppSelector((state) => state.member?.memberData)
  const roomData = useAppSelector((state) => state.room?.roomData)

  const roomId = router.query?.roomId as string

  const { data: roomInfoData } = useQuery([QUERY_KEY.FETCH_ROOM_DATA, { roomId }], () => fetchRoomData({ roomId: roomId as string }), {
    enabled: !!roomId && router.isReady,
    cacheTime: 0,
    onSuccess: (data) => {
      dispatch(setRoomData({ roomData: data }))

      const { roomId, memberInfoId, coverPhotoUrl, liveSourceType, liveSource } = data

      const fixedPlayerData = { roomId, coverPhotoUrl, hostMemberInfoId: memberInfoId, liveUrlInfo: [], liveSourceType, liveSource }

      dispatch(setFixedPlayerData({ fixedPlayerData }))
    },
  })

  // 房間產品資訊
  const { productList, isRoomProductDataFetching, refetchRoomProductData } = useLiveRoomProduct({ roomId, liveRoomProductDataSSR })

  const isLive = roomInfoData?.liveType === ROOM_LIVE_TYPE.CURRENT
  const isFuture = roomInfoData?.liveType === ROOM_LIVE_TYPE.FUTURE
  const isHost = memberData?.memberInfoId === roomData?.memberInfoId || memberData?.role === ROLE.IT
  const targetDate = parseISO(roomData.startTime)
  const currentDate = new Date()
  const minutesDifference = differenceInMinutes(targetDate, currentDate)
  const isLessThenOneHour = minutesDifference <= 60 // 目前定義 start time

  return (
    <LiveRoomProductContext.Provider value={{ isRoomProductDataFetching, refetchRoomProductData }}>
      <div className={cx('product')}>
        <ProductList
          className={cx('product-list')}
          productList={productList}
          isLive={isLive}
          isLessThenOneHour={isLessThenOneHour}
          isHost={isHost}
          isFuture={isFuture}
        />
      </div>
    </LiveRoomProductContext.Provider>
  )
}

export default LiveRoomProduct
